const state = {
    purchaseorders: [],
    purchaseorderId: [],
    loading: false,
    documents: [],
    file: null,
    docLoader: false,
};

export default state;